// assets/variant-drawer.js
// Simpel drawer toggle til variantvælger

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    var toggle = e.target.closest('.js-variant-drawer-toggle');
    if (!toggle) return;
    var drawerId = toggle.dataset.drawerId;
    if (!drawerId) return;
    var drawer = document.getElementById(drawerId);
    var overlay = document.querySelector('.variant-drawer__overlay[data-drawer-overlay-for="' + drawerId.replace('variant-drawer-', '') + '"]');
    if (!drawer) return;
    var isOverlay = toggle.classList.contains('variant-drawer__overlay');
    var isOpen = drawer.classList.contains('open');
    // Luk alle drawers
    document.querySelectorAll('.variant-drawer.open').forEach(function(d) { d.classList.remove('open'); });
    document.querySelectorAll('.variant-drawer__overlay.open').forEach(function(o) { o.classList.remove('open'); });
    // Remove manual scroll lock (handled by DialogElement system)
    document.body.style.overflow = '';
    // Fjern alle overlays (også hvis de ikke har .open)
    document.querySelectorAll('.variant-drawer__overlay').forEach(function(o) { o.classList.remove('open'); });
    // Failsafe: Remove .lock from <html> if no dialogs/drawers are open
    setTimeout(function() {
      if (!document.querySelector('.variant-drawer.open') && !document.querySelector('dialog-element[open]') && !document.querySelector('x-drawer[open]')) {
        document.documentElement.classList.remove('lock');
      }
    }, 100);
    // Hvis ikke åben, åbn denne
    if (!isOpen) {
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      // Remove manual scroll lock (handled by DialogElement system)
      document.body.style.overflow = '';
    }
  });
});
